import { render, staticRenderFns } from "./EntityNewsStatisticsDialog.vue?vue&type=template&id=9b8b5092&scoped=true"
import script from "./EntityNewsStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./EntityNewsStatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./EntityNewsStatisticsDialog.vue?vue&type=style&index=0&id=9b8b5092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8b5092",
  null
  
)

export default component.exports